module.exports = __webpack_public_path__ + "img/logos/app-icon-d785d51d4b230c540e5bf92d5aad4903.svg";